import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WorkflowRunStep } from 'dashboard/models/workflow-step';

export interface WorkflowEditorState {
  moduleRunStepsByConfigStepToken: Record<string, WorkflowRunStep[]>; // move to slices of workflow-run eventually
}

export const initialState: WorkflowEditorState = {
  moduleRunStepsByConfigStepToken: {},
};

const { reducer, actions } = createSlice({
  name: 'workflow-editor',
  initialState,
  reducers: {
    clearWorkflowEditor: () => {
      return initialState;
    },
    setModuleRunStepsByConfigStepToken: (
      state,
      action: PayloadAction<WorkflowEditorState['moduleRunStepsByConfigStepToken']>,
    ) => {
      state.moduleRunStepsByConfigStepToken = action.payload;
    },
  },
});

export const { clearWorkflowEditor, setModuleRunStepsByConfigStepToken } = actions;

export const workflowEditorReducer = reducer;
